import React, { createContext } from 'react';
import { FieldData, GroupData, TableFieldsItemData } from './api';
import { AppContext, AppContextData } from 'AppContext';

interface MeetupContextProps {
  meetupId: number;
}

interface MeetupContextData {
  meetupId: number;
  fields: Array<FieldData>;
  groups: GroupData[];
  tableFields: TableFieldsItemData[] | null;
  update: () => void;
}

interface MeetupContextState {
  loading: boolean;
  fields: Array<FieldData>;
  groups: GroupData[];
  tableFields: TableFieldsItemData[] | null;
}

const MeetupContext = createContext<MeetupContextData>({
  meetupId: -1,
  fields: [],
  groups: [],
  tableFields: null,
  update: () => {},
});

class MeetupContextProvider extends React.Component<MeetupContextProps, MeetupContextState> {
  static contextType = AppContext;

  constructor(props: MeetupContextProps) {
    super(props);
    this.state = {
      fields: [],
      groups: [],
      tableFields: null,
      loading: true,
    };
  }

  componentDidMount(): void {
    this.getSettings();
  }

  getSettings = () => {
    if (this.props.meetupId) {
      let ctx = this.context as AppContextData;
      ctx.configApi
        .getSettings(this.props.meetupId)
        .then(({ data: settings }) => {
          ctx.groupApi
            .listGroups(this.props.meetupId)
            .then(({ data: groups }) => {
              this.setState({
                fields: settings.fields.fields!,
                groups: groups!,
                tableFields: settings.tableFields ?? null,
                loading: false,
              });
            })
            .catch(ctx.errorHandler);
        })
        .catch(ctx.errorHandler);
    } else {
      this.setState({
        fields: [],
        groups: [],
        tableFields: null,
        loading: false,
      });
    }
  };

  errorHandler = (error: any) => {
    console.log('MeetupContext error handler', error);
    const { config, data } = error.response;
  };

  render() {
    if (this.state.loading) return null;
    return (
      <MeetupContext.Provider
        value={{
          meetupId: this.props.meetupId,
          fields: this.state.fields,
          groups: this.state.groups,
          tableFields: this.state.tableFields,
          update: this.getSettings,
        }}
      >
        {this.props.children}
      </MeetupContext.Provider>
    );
  }
}

export { MeetupContext, MeetupContextProvider };
